// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RegexConstants$PorterinUtils from "../constants/RegexConstants.mjs";

function hasAtleastOneAlphabet(word) {
  return RegexConstants$PorterinUtils.hasAtleastOneAlphabetRegex.test(word);
}

function hasParams(url) {
  return RegexConstants$PorterinUtils.hasParamsRegex.test(url);
}

export {
  hasAtleastOneAlphabet ,
  hasParams ,
}
/* No side effect */
